export default __webpack_public_path__ + "static/media/provision.b7a1034c.svg";